<div class="flex flex-col items-center h-full bg-gray-100 px-4 py-6">

    <!-- Bouton Sortie / Back -->
    <div class="w-full max-w-[950px] flex justify-start mb-4">
        <div class="flex flex-col items-center cursor-pointer" (click)="goBack()">
            <button class="w-12 h-12 bg-blue-700 hover:bg-blue-800 text-white rounded-sm flex items-center justify-center shadow">
                <i class="fas fa-chevron-left text-lg"></i>
            </button>
            <span class="text-sm text-gray-700 mt-1">Sortie</span>
        </div>
    </div>

    <!-- Photo -->
    <div class="mb-6">
        <app-photo-capture
            (photoCaptured)="onPhotoCaptured($event)"
            (photoFile)="onPhotoFile($event)">
        </app-photo-capture>
    </div>

    <!-- Nom -->
    <div class="w-full max-w-md mb-4">
        <p class="text-gray-700 text-center mb-2">
            Entrez votre nom (Commencer à saisir et sélectionner)
        </p>
        <app-multi-select
            [options]="activeVisitorsLookup()"
            [isMultiselect]="false"
            [minChars]="3"
            [placeholder]="'Select your name'"
            [maxItems]="1"
            [selectedKeys]="selectedVisitorId()"
            (selectedKeysChange)="onVisitorSelectChange($event)">
        </app-multi-select>
    </div>

    <!-- Profil non trouvé -->
    @if (profileNotFound()) {
    <div class="w-full max-w-md bg-white rounded shadow p-4 flex items-start gap-4 mb-6">
        <div class="w-12 h-12 rounded-full bg-red-500 flex items-center justify-center text-white text-xl shrink-0">
            <i class="fas fa-times"></i>
        </div>
        <div>
            <p class="font-bold text-gray-900">Profil non trouvé</p>
            <p class="text-sm text-gray-600">Votre profil n'a pas été trouvé.</p>
        </div>
    </div>
    }

    <!-- Profil trouvé (checkout auto sans feedback) -->
    @if (profileFound()) {
    <div class="w-full max-w-md bg-white rounded shadow p-4 flex items-start gap-4 mb-6">
        <div class="w-12 h-12 rounded-full bg-green-500 flex items-center justify-center text-white text-xl shrink-0">
            <i class="fas fa-check"></i>
        </div>
        <div>
            <p class="font-bold text-gray-900">Profil trouvé</p>
            <p class="text-sm text-gray-600">Sortie enregistrée pour {{ selectedVisit()?.visitor?.fullname }}.</p>
        </div>
    </div>
    }

    <!-- Feedback + Checkout -->
    @if (showFeedbackForm()) {
    <div class="w-full max-w-md bg-white rounded shadow p-6 mb-6">
        <p class="text-center text-gray-700 mb-4">Que pensez-vous de votre visite aujourd'hui?</p>

        <div class="flex justify-center gap-8 mb-6">
            <div class="cursor-pointer transition hover:scale-110"
                (click)="setFeedbackScore(1)"
                [class.opacity-40]="feedbackScore() !== 3 && feedbackScore() !== undefined">
                <app-bubble-smiley [score]="1" [showAsBubble]="false" [showAsSelected]="feedbackScore() === 1" size="w-16 h-16"></app-bubble-smiley>
            </div>
            <div class="cursor-pointer transition hover:scale-110"
                (click)="setFeedbackScore(2)"
                [class.opacity-40]="feedbackScore() !== 2 && feedbackScore() !== undefined">
                <app-bubble-smiley [score]="2" [showAsBubble]="false" [showAsSelected]="feedbackScore() === 2" size="w-16 h-16"></app-bubble-smiley>
            </div>
            <div class="cursor-pointer transition hover:scale-110"
                (click)="setFeedbackScore(3)"
                [class.opacity-40]="feedbackScore() !== 1 && feedbackScore() !== undefined">
                <app-bubble-smiley [score]="3" [showAsBubble]="false" [showAsSelected]="feedbackScore() === 3" size="w-16 h-16"></app-bubble-smiley>
            </div>
        </div>

        <p class="text-sm text-gray-600 mb-2">Commentaires</p>
        <textarea [(ngModel)]="feedbackComment" rows="3" class="w-full border border-gray-300 rounded p-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"></textarea>

        <div class="flex justify-end">
            <button (click)="submitCheckout()"
                class="px-6 py-2 bg-green-500 hover:bg-green-600 text-white rounded shadow font-semibold uppercase">
                Sortir
            </button>
        </div>
    </div>
    }

    <!-- Footer -->
    <div class="mt-auto w-full max-w-[950px] flex justify-between items-center px-4 py-3">
        <button (click)="goBack()"
            class="w-12 h-12 bg-blue-700 hover:bg-blue-800 text-white rounded-sm flex items-center justify-center shadow">
            <i class="fas fa-chevron-left text-lg"></i>
        </button>
        <button (click)="goHome()" class="flex items-center gap-2 text-gray-700 hover:text-gray-900">
            <i class="fas fa-home text-2xl"></i>
            <span>Retour à la page d'accueil</span>
        </button>
        <div class="w-12"></div>
    </div>

</div>